import FormSandboxCtl from 'root/main/components/forms/formSandboxCtl';
import lightboxFormInit from 'root/main/components/forms/lightbox/lightboxFormInit';

const forms = [
    {
        selector: 'button[data-select=form-submit]',
        path: { filename: 'formControllerInit' },
    },
    {
        selector: '[data-form-custom=agnostic-business-type]',
        path: { filename: 'agnosticFormControllerInit' },
    },
    {
        selector: '[data-form-name*=email_only]',
        path: { filename: 'emailOnlyFormCtl' },
    },
    {
        selector: '[data-form-name=resto_resources_tool]',
        path: { filename: 'menuTemplate' },
    },
    {
        selector: '[data-form=ls-form]',
        path: { filename: 'formUIInit' },
    },
    {
        selector: '[data-form=ls-form-steps]',
        path: { filename: 'formUISliderInit' },
    },
    {
        selector: '[data-form-name=other_partner_application]',
        path: { filename: 'formUIConditionalInit' },
    },
    {
        selector: '[data-auto-fill-form-values]',
        path: { filename: 'autoFillFormValues' },
    },
];

const lightboxHandler = (event: Event) => {
    const target =
        event.target instanceof HTMLElement
            ? event.target.closest<HTMLAnchorElement>('A')
            : null;
    if (target && target.href) {
        const url = new URL(target.href);

        // Store URL click context for global use by VWO variation handler on first segmentation click
        window.formSandboxContext = {
            targetURL: target.href,
            event,
        };

        if (url.hash.endsWith('form-sandbox')) {
            event.preventDefault();
            FormSandboxCtl().init(event, target.href);
            return;
        }
        if (url.hash.startsWith('#lightbox|')) {
            event.preventDefault();
            lightboxFormInit(event, decodeURI(target.href));
            return;
        }
    }
};

export { forms, lightboxHandler };
